import React, { useEffect } from "react";
import { useState } from "react";
import { Avatar, Box, Button, Center, Navbar, Text } from "@mantine/core";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { LinksGroup } from "../NavbarLinksGroup";
import useStyles from "./style";
import { isSubscriptionExpired, removeCookie } from "../../utils";
import { useSelector, useDispatch } from "react-redux";
import mixpanel from "mixpanel-browser";
import { DashboardSvg } from "../Svgs/DashboardSvg";
import { FacilitySvg } from "../Svgs/FacilitySvg";
import { StaffIconSvg } from "../Svgs/StaffIconSvg";
import { ClientIconDashboardSvg } from "../Svgs/ClientIconDashboardSvg";
import { MedicationSvg } from "../Svgs/MedicationSvg";
import { TaskSvg } from "../Svgs/TaskSvg";
import { NoteIconSvg } from "../Svgs/NoteIconSvg";
import { ReportIconSvg } from "../Svgs/ReportIconSvg";
import { LogoutSvg } from "../Svgs/LogoutSvg";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import SettingsIcon from "../Svgs/SettingsIcon";
import BillingiconSvg from "../Svgs/BillingiconSvg";
import BillingInvoiceIconSvg from "../Svgs/BillingInvoiceIconSvg";
import ToolTip from "../ToolTip/ToolTip";
import StaffDashboardSvg from "../Svgs/StaffDashboardSvg";
import CommandCenterSvg from "../Svgs/CommandCenterSvg";
import { useMediaQuery } from "@mantine/hooks";
import { getSignatureById } from "../../services/signature";

export default function Nav({ isSidebarOpen, setIsSidebarOpen }) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const { profile } = useSelector((state) => state?.profile);

  const DEFAULT_STAFF_NOT_SEE = ["Facility", "Staff", "Billing", "Invoice"];
  const [staffAdminNotSee, setStaffAdminNotSee] = useState([]);
  const [staffNotSee, setStaffNotSee] = useState(DEFAULT_STAFF_NOT_SEE);
  const isSettingsPage = window.location.pathname.includes("/home/settings");
  const pathNames = window.location.pathname;
  const MobileScreen = useMediaQuery("(max-width: 500px)");

  const data = [
    {
      to: "/home",
      label: isSidebarOpen && (profile?.user?.role === "staff" ? "Dashboard" : "Command Center"),
      tooltipLabel: profile?.user?.role === "staff" ? "Dashboard" : "Command Center",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          {profile?.user?.role === "staff" ? (
            <StaffDashboardSvg pathNames={pathNames} />
          ) : (profile?.user?.role === "admin" || profile?.user?.type === "contractor") ? (
            <CommandCenterSvg pathNames={pathNames} />
          ) : (
            <DashboardSvg pathNames={pathNames} />
          )}
        </Box>
      ),
    },
    {
      to: "facility",
      label: isSidebarOpen && "Facility",
      tooltipLabel: "Facility",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <FacilitySvg pathNames={pathNames} />
        </Box>
      ),
    },
    {
      to: "staff",
      label: isSidebarOpen && "Staff",
      tooltipLabel: "Staff",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <StaffIconSvg pathNames={pathNames} />
        </Box>
      ),
    },
    {
      to: "patient",
      label: isSidebarOpen && "Client",
      tooltipLabel: "Client",
      matchPaths: ["client"],
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <ClientIconDashboardSvg pathNames={pathNames} />
        </Box>
      ),
    },

    {
      to: "medication",
      label: isSidebarOpen && "Medication",
      tooltipLabel: "Medication",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <MedicationSvg pathNames={pathNames} />
        </Box>
      ),
    },
    {
      to: "tasks",
      label: isSidebarOpen && "Task",
      tooltipLabel: "Task",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <TaskSvg pathNames={pathNames} />
        </Box>
      ),
    },
    {
      to: "note",
      label: isSidebarOpen && "Note",
      tooltipLabel: "Note",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <NoteIconSvg pathNames={pathNames} />
        </Box>
      ),
    },
    {
      // to: "billing-claim-form",
      to: "billing",
      label: isSidebarOpen && "Billing",
      tooltipLabel: "Billing",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <BillingiconSvg pathNames={pathNames} />
        </Box>
      ),
    },

    {
      to: "invoices",
      label: isSidebarOpen && "Invoice",
      tooltipLabel: "Invoice",
      imgsrc: (
        <Box pos={"relative"} top={!isSidebarOpen && 6}>
          <BillingInvoiceIconSvg pathNames={pathNames} />
        </Box>
      ),
    },
    // {
    //   to: "report",
    //   label: isSidebarOpen && "Reports",
    //   tooltipLabel: "Report",
    //   imgsrc: (
    //     <Box pos={"relative"} top={!isSidebarOpen && 6}>
    //       <ReportIconSvg pathNames={pathNames} />
    //     </Box>
    //   ),
    // },
  ];

  useEffect(() => {
    const permissions = profile?.user?.permissions;
    const role = profile?.user?.role;

    if (!role && !profile?.user?.type) {
      setStaffAdminNotSee([]);
      return;
    }

    if (
      (role === "admin" || role === "contractor") &&
      (!permissions || typeof permissions !== "object")
    ) {
      setStaffAdminNotSee(["Billing"]);
      return;
    }

    // const hiddenFields = Object.entries(permissions || {})
    //   .filter(([key, value]) => key !== "aiAccess" && value === false)
    //   .map(([key]) => key.charAt(0).toUpperCase() + key.slice(1));

    const hiddenFields = Object.entries(permissions || {})
      .filter(([key, value]) => {
        if (key === "aiAccess") return false; // always skip
        if (key === "billing") {
          // hide if billing is false
          return value === false;
        }
        // hide other fields if their value is false
        return value === false;
      })
      .map(([key]) => key.charAt(0).toUpperCase() + key.slice(1));
    // extra check: if billing key does NOT exist, hide it
    if (!("billing" in (permissions || {}))) {
      hiddenFields.push("Billing");
    }

    if (role === "admin" || role === "contractor") {
      setStaffAdminNotSee(hiddenFields);
    } else if (role === "staff") {
      const combined = [...DEFAULT_STAFF_NOT_SEE, ...hiddenFields];
      setStaffNotSee([...new Set(combined)]);
    }
  }, [profile?.user?.permissions]);

  useEffect(() => {
    getSignatureById();
  }, []);

  useEffect(() => {
    const handler = () => setIsOpen(true);
    window.addEventListener("openMobileDrawer", handler);
    return () => window.removeEventListener("openMobileDrawer", handler);
  }, []);

  const links =
    profile?.user?.type !== "staff"
      ? data?.map((item, i) => (
          <LinksGroup
            {...item}
            setIsOpen={setIsOpen}
            key={i}
            isSidebarOpen={isSidebarOpen}
          />
        ))
      : profile?.user?.type === "staff" &&
          (profile?.user?.role === "admin" ||
            profile?.user?.role === "contractor")
        ? data
            ?.filter((item) => !staffAdminNotSee?.includes(item?.tooltipLabel))
            ?.map((item, i) => (
              <LinksGroup
                {...item}
                setIsOpen={setIsOpen}
                key={i}
                isSidebarOpen={isSidebarOpen}
              />
            ))
        : data
            ?.filter((item) => !staffNotSee?.includes(item?.tooltipLabel))
            ?.map((item, i) => (
              <LinksGroup
                {...item}
                setIsOpen={setIsOpen}
                key={i}
                isSidebarOpen={isSidebarOpen}
              />
            ));
  const navigate = useNavigate();

  const location = useLocation();
  const isDashboardPage =
    location.pathname === "/home/dashboard" || location.pathname === "/home"
      ? true
      : false;

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  // Function to toggle the navbar visibility
  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <Navbar
        pt={0}
        height={"100vh"}
        // width={{ sm: 220, md: 250, lg: 260, xl: 280 }}
        width={{
          sm: isSidebarOpen ? 220 : 70,
          md: isSidebarOpen ? 250 : 70,
          lg: isSidebarOpen ? 260 : 70,
          xl: isSidebarOpen ? 280 : 70,
        }}
        p={10}
        className={
          Boolean(localStorage.getItem("isProviderView")) === true
            ? [classes.adminSidebar, classes.adminSidebarWithSkyPointHeader]
            : classes.adminSidebar
        }
      >
        <Center
          pt={0}
          pl={{ xs: 0, sm: 0 }}
          pr={{ xs: 10, sm: 0 }}
          className={classes.header}
        >
          <Link
            to={
              isSubscriptionExpired()
                ? "/home/settings?selectedTab=upgrade"
                : "/home/dashboard"
            }
            aria-disabled
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                // justifyContent: "space-between",
              }}
            >
              {isSidebarOpen === true ? (
                <img
                  src="/assets/images/logo2.png"
                  alt="Logo"
                  style={{ width: "50%", marginTop: "10px" }}
                />
              ) : (
                <img
                  src="/assets/images/logoIcon.png"
                  alt="Logo"
                  style={{ width: "80%", marginTop: "20px" }}
                />
              )}
            </div>
          </Link>
          <Button
            onClick={() => setIsSidebarOpen((prev) => !prev)}
            className={classes.openCloseSidebarBtn}
          >
            {isSidebarOpen ? <IoIosArrowBack /> : <IoIosArrowForward />}
          </Button>
        </Center>
        {isSidebarOpen === true ? (
          <Text c={"gray"} ff={"Inter"} fw={"400"} ml={10} fz={12} mb={5}>
            MENU
          </Text>
        ) : (
          ""
        )}

        <Navbar.Section
          grow
          // className="sidebaritem"
          className={`sidebaritem ${classes.mainNavLinks}`}
          style={{ overflowY: "auto", color: "#667085" }}
        >
          {links}
        </Navbar.Section>
        <div style={{ overflowY: "auto" }}>
          <></>
          <Navbar.Section className={classes.footer}>
            {/* Redirect to settings page */}

            <Link
              className={
                isSettingsPage
                  ? `${classes.link} ${classes.linkActive} ${
                      !isSidebarOpen && classes.closedDrawerSettings
                    }`
                  : classes.link
              }
              to={"/home/settings"}
            >
              <Box className={classes.bottomLinksStyling}>
                {isSidebarOpen ? (
                  <>
                    <SettingsIcon />
                    <Text className={classes.bottomLinksText}>Settings</Text>
                  </>
                ) : (
                  <ToolTip
                    position={"right-end"}
                    toolTipLabel={"Settings"}
                    imgsrc={<SettingsIcon />}
                  />
                )}
              </Box>
            </Link>

            <div className={classes.hrElemDiv} />
            {/* Logout user */}

            <Link
              onClick={() => {
                removeCookie("token");
                removeCookie("skypoint_token");
                localStorage.removeItem("isProviderView");
                mixpanel.track("Logout");
                mixpanel.reset();
                dispatch({ type: "RESET_STORE" });
              }}
              className={classes.link}
              to={"/"}
            >
              <Box className={classes.bottomLinksStyling}>
                {isSidebarOpen ? (
                  <>
                    <LogoutSvg />
                    <Text className={classes.bottomLinksText}>Logout</Text>
                  </>
                ) : (
                  <ToolTip
                    position={"right-end"}
                    toolTipLabel={"Logout"}
                    imgsrc={<LogoutSvg />}
                  />
                )}
              </Box>
            </Link>
          </Navbar.Section>
        </div>
      </Navbar>

      {isOpen ? (
        <div className={classes?.customDrawerOpen}>
          <span onClick={toggleNavbar}>
            <img width={25} src="/assets/images/closeIcon.png" alt="close" />
          </span>
          <div className={classes.drawerContent}>
            <Navbar.Section grow className="sidebaritem">
              <Center className={classes.header}>
                <Link to={"/home"}>
                  <img
                    width={"50%"}
                    src="/assets/images/logo2.png"
                    alt="Logo"
                  />
                </Link>
              </Center>
              {links}
            </Navbar.Section>
            <Navbar.Section className={classes.footer}>
              <Link
                aria-label="logout button"
                className={classes.link}
                to={"/"}
                onClick={() => {
                  removeCookie("token");
                  removeCookie("skypoint_token");
                  localStorage.removeItem("isProviderView");
                  mixpanel.track("Logout");
                  mixpanel.reset();
                  dispatch({ type: "RESET_STORE" });
                  navigate("/");
                }}
              >
                <LogoutSvg />
                <span role="button" aria-label="Logout">
                  Logout
                </span>
              </Link>
            </Navbar.Section>
          </div>
        </div>
      ) : (
        <div className={classes.customDrawer}>
          <div className={classes.drawerContent}></div>
        </div>
      )}
      <div className={classes.menuIconContainer}>
        <img
          src="/assets/images/menu.png"
          className={classes?.menu}
          onClick={toggleDrawer}
          alt="menu toggle"
        />
        <NavLink to={"/home/settings"}>
          <Avatar
            size={MobileScreen ? "md" : "lg"}
            radius="xl"
            className={classes?.avatar}
            src={profile?.user?.photo}
          />
        </NavLink>
      </div>
    </div>
  );
}
